import getQueryParamsFromStringObjectUtil from 'utils/object/get-query-params-from-string'
import logUtil from 'utils/log'

export default function getInitialFriendIndexUtil (props) {
  const search = window.location.search
  const queryParams = getQueryParamsFromStringObjectUtil(search || '')
  const debugProps = {
    search,
    queryParams,
    props
  }
  logUtil('getInitialFriendIndexUtil').debug('debugProps=', debugProps)
  const value = queryParams.friend_id
  const initialFriendId = Array.isArray(value) ? value[value.length - 1] : value
  /**
   * @type {import('modules/squad/types').GetSquadInfoResp.squad_members}
   */
  const members = props.members
  let initialFriendIndex
  if (initialFriendId) {
    initialFriendIndex = members.findIndex(member => member.squad_member_customer_id === Number(initialFriendId))
  }
  return initialFriendIndex
}
